import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "settings-fixed-header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "settings-fixed-header--title" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Profile"),
  /*#__PURE__*/_createElementVNode("small", { class: "c-primary-grey" }, "Your account information")
], -1)
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { class: "profile-wrapper with-fixed-header" }
const _hoisted_5 = { class: "profile__avatar m-left-40 m-right-25 m-top-60" }
const _hoisted_6 = { class: "profile__info-wrapper" }
const _hoisted_7 = { class: "profile__info-block" }
const _hoisted_8 = { class: "profile__inputs-block" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h2", null, "Personal Information", -1)
const _hoisted_10 = { class: "profile__inputs" }
const _hoisted_11 = { class: "profile__inputs--column" }
const _hoisted_12 = { class: "profile__inputs--column" }
const _hoisted_13 = { class: "profile__info-block" }
const _hoisted_14 = { class: "profile__inputs-block" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h2", null, "Contact Information", -1)
const _hoisted_16 = { class: "profile__inputs" }
const _hoisted_17 = { class: "profile__inputs--column" }
const _hoisted_18 = { class: "profile__inputs--column" }
const _hoisted_19 = { class: "profile__info-block" }
const _hoisted_20 = { class: "profile__inputs-block" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createTextVNode(" Company Information "),
  /*#__PURE__*/_createElementVNode("span", null, "(Prior to running the job type NCOA, we are required to have a signed PAF form)")
], -1)
const _hoisted_22 = { class: "profile__inputs" }
const _hoisted_23 = { class: "profile__inputs--column" }
const _hoisted_24 = { class: "profile__inputs--dropdown-header" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "t-a-l t-t-c" }
const _hoisted_27 = { class: "profile__inputs--column" }
const _hoisted_28 = { class: "nacis-title" }
const _hoisted_29 = { class: "c-primary-grey" }
const _hoisted_30 = { class: "profile__info-block m-bottom-87" }
const _hoisted_31 = { class: "profile__inputs-block" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("h2", null, "Security", -1)
const _hoisted_33 = { class: "profile__inputs" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "profile__inputs--column" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "c-primary-grey" }, " You can set a new password, a link to change the password will be sent to your email. ")
], -1)
const _hoisted_35 = { class: "profile__inputs--column" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalEditAvatar = _resolveComponent("ModalEditAvatar")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_IconsService = _resolveComponent("IconsService")!
  const _component_base_input = _resolveComponent("base-input")!
  const _component_base_dropdown = _resolveComponent("base-dropdown")!
  const _component_NAICSCode = _resolveComponent("NAICSCode")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isShowModalEditAvatar)
      ? (_openBlock(), _createBlock(_component_ModalEditAvatar, {
          key: 0,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isShowModalEditAvatar = false))
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("button", {
        class: "btn fill t-t-u medium",
        disabled: !Object.keys(_ctx.editProfileData).length,
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.saveChanges && _ctx.saveChanges(...args)))
      }, " Save changes ", 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_Avatar, {
          class: "m-bottom-15",
          size: 132
        }),
        _createElementVNode("button", {
          class: "btn border mini",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isShowModalEditAvatar = true))
        }, " Edit photo ")
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_IconsService, {
            class: "profile__info--icon",
            icon: "person"
          }),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_base_input, {
                  title: "First name",
                  value: _ctx.profile.first_name,
                  onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleChangeProfile('first_name', $event)))
                }, null, 8, ["value"]),
                _createVNode(_component_base_input, {
                  title: "Company name",
                  value: _ctx.profile.company_name,
                  onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleChangeProfile('company_name', $event)))
                }, null, 8, ["value"])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_base_input, {
                  title: "Last name",
                  value: _ctx.profile.last_name,
                  onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleChangeProfile('last_name', $event)))
                }, null, 8, ["value"])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_IconsService, {
            class: "profile__info--icon",
            icon: "house"
          }),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_base_input, {
                  title: "Email Address",
                  disabled: "",
                  value: _ctx.profile.email
                }, null, 8, ["value"]),
                _createVNode(_component_base_input, {
                  title: "Notifications Email",
                  value: _ctx.profile.notifications_email,
                  onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleChangeProfile('notifications_email', $event)))
                }, null, 8, ["value"])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_base_input, {
                  title: "Phone Number",
                  value: _ctx.profile.phone_number,
                  onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.handleChangeProfile('phone_number', $event)))
                }, null, 8, ["value"])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_IconsService, {
            class: "profile__info--icon",
            icon: "briefcase"
          }),
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_component_base_input, {
                  title: "Company Address",
                  value: _ctx.profile.company_address,
                  onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.handleChangeProfile('company_address', $event)))
                }, null, 8, ["value"]),
                _createVNode(_component_base_dropdown, {
                  class: "profile__inputs--dropdown",
                  title: "Company State",
                  placeholder: "Select company state"
                }, _createSlots({
                  list: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.STATE_NAME, (state, id) => {
                      return (_openBlock(), _createElementBlock("li", {
                        class: "base-dropdown__list--item",
                        key: id,
                        onClick: ($event: any) => (_ctx.selectState(state))
                      }, [
                        _createElementVNode("button", _hoisted_26, _toDisplayString(state), 1)
                      ], 8, _hoisted_25))
                    }), 128))
                  ]),
                  _: 2
                }, [
                  (_ctx.editProfileData?.company_state || _ctx.profile.company_state)
                    ? {
                        name: "head",
                        fn: _withCtx(() => [
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("p", null, _toDisplayString(_ctx.editProfileData?.company_state || _ctx.profile.company_state), 1)
                          ])
                        ])
                      }
                    : undefined
                ]), 1024),
                _createVNode(_component_NAICSCode, {
                  value: _ctx.profile.naics_code,
                  onNaics: _ctx.handleChangeNAICS
                }, null, 8, ["value", "onNaics"])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createVNode(_component_base_input, {
                  title: "Company City",
                  value: _ctx.profile.company_city,
                  onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.handleChangeProfile('company_city', $event)))
                }, null, 8, ["value"]),
                _createVNode(_component_base_input, {
                  title: "Company ZIP",
                  value: _ctx.profile.company_zip,
                  onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.handleChangeProfile('company_zip', $event)))
                }, null, 8, ["value"]),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("p", _hoisted_29, _toDisplayString(_ctx.NAICSTitle), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createVNode(_component_IconsService, {
            class: "profile__info--icon",
            icon: "lock"
          }),
          _createElementVNode("div", _hoisted_31, [
            _hoisted_32,
            _createElementVNode("div", _hoisted_33, [
              _hoisted_34,
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("button", {
                  class: "btn fill mini medium",
                  onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.resetPassword && _ctx.resetPassword(...args)))
                }, "Reset password")
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}